import Styled from 'styled-components';
import { SearchOutlined } from '@ant-design/icons';
import { Button } from '../../../buttons/buttons';

const CustomListItem = Styled.li`
  background: ${({ theme }) => theme['bg-color-normal']};
  border-radius:5px;

  & .ant-checkbox-wrapper {
    display: flex;
    flex-direction: row;
    padding:10px;
    margin:10px 0px;
  }
  .ant-checkbox + span {
    flex: 1;
  }
`;

const SelectItem = Styled.button`
  background: #eee;
`;

const PanelButton = Styled(Button)`
  height: 30px;
  width: 30px;
  padding: 0;
`;

const CollapseContainer = Styled.div`
  margin: 10px 5px 20px;
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`;

const IconSearch = Styled(SearchOutlined)`
font-size: 20px;
color:${({ theme }) => theme['gray-solid']};
`

export { CustomListItem, SelectItem, PanelButton, CollapseContainer, IconSearch };
